module.exports = __webpack_public_path__ + "static/media/facebook.0cca1c1a.svg";